import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CoreService } from 'src/app/@amiga-pyme/services/core.service';
import { lastValueFrom } from 'rxjs';
import {
  ReposicionPayload,
  TransferBatchResponse
} from 'src/app/pages/operations/reposicion/models/reposicion.model';

@Injectable({ providedIn: 'root' })
export class BranchStoreService extends CoreService {
  private route = '/branch-stores';

  constructor(http: HttpClient) {
    super(http);
  }

  /* ===============================
        OBTENER SUCURSALES
  =============================== */

  async getByBusiness() {
    const response = await lastValueFrom(
      this.request({
        method: 'GET',
        url: `${this.route}/by-business`
      })
    );

    return this.refactorResponse(response);
  }

  /* ===============================
        PRODUCTOS ALMACEN MATRIZ
  =============================== */

  async getMatrixProducts(branchStoreIds: string[]) {
    const ids = `[${branchStoreIds.join(',')}]`;

    const response = await lastValueFrom(
      this.request({
        method: 'GET',
        url: `${this.route}/by-business?isMatrix=true&branchStoreIds=${ids}`
      })
    );

    return this.refactorResponse(response);
  }

  /* ===============================
        CREAR TRANSFERENCIA (POST)
  =============================== */

  async createTransferBatch(
    payload: ReposicionPayload
  ): Promise<TransferBatchResponse> {
    const response = await lastValueFrom(
      this.request({
        method: 'POST',
        url: '/operation/transfers/batch',
        data: payload
      })
    );

    return this.refactorResponse(response) as TransferBatchResponse;
  }
}
